import type { FeatureRoutes } from '@/app/screens'
import { isKiosk } from './kiosk'

export default {
  routes: [{
    path: '/wall',
    component: () => import('./WallPage.vue'),
    meta: {
      perm: 'monitor.view',
      layout: 'bare',
      // A TV screen reads the wall with its screen token alone: no session, no login.
      standalone: (to) => isKiosk(to.hash),
    },
  }],
} satisfies FeatureRoutes
